import { Row, Col } from "antd";
import React from "react";
import { Redirect } from "react-router-dom";

interface Props {}

export const Home = (props: Props) => {
  return (
    <>
      <Row>
        <Redirect to="/signup" /> 
      </Row>
    </>
  );
};
